export default {
    light: {
        baseBg: 'bg-white',
        tabsContainerBg: 'bg-white',
        borderBlockColor: 'border-gray-200',
        secondBaseBg: 'm-light-bg',
        baseTextColor: 'text-black',
        activeTabBg: 'bg-blue-100',
        activeTabTextColor: 'text-blue-700',
        tabTextColor: 'text-gray-600',
        iconBgSettingTextColor: 'text-gray-600',
        cardBg: 'bg-transparent m-light-card-border-color border',
        cardBorderColor: 'm-light-card-border-color',
        cardLabelTextColor: 'text-gray-600',
        lightButtonBg: 'bg-transparent',
        lightButtonTextColor: 'text-gray-600',
        navBg: 'bg-black',
        navBorderColor: 'border-gray-100',
        navActiveBg: 'bg-gray-100',
        navActiveTextColor: 'm-yellow-color',
        navActiveTextColor2: 'text-blue-600',
        borderColorCoin: 'm-light-border-coin-color',
        dangerPnlColor: 'text-red-600',
        successPnlColor: 'm-green-color',
        bgDangerColor: 'bg-red-600',
        bgSuccessPnlColor: 'm-green-bg',
        loaderFill: 'fill-blue-600',
        cardDivideColor: 'divide-gray-200',
        cardDivideColor1: 'divide-gray-100',
        menuBtnBg: 'bg-gray-100',
        menuBtnTextColor: 'text-gray-400',
        chartPlaceBg: 'bg-white',
        placeBg: 'bg-gray-200',
        placeTextColor: 'text-gray-200',
        outlineBtnBg: 'bg-blue-100',
        outlineBtnTextColor: 'text-blue-700',
        spinnerTextColor: 'text-blue-700',
        inputBg: 'bg-white',
        inputRingColor: 'ring-transparent',
        inputBorderColor: 'border-transparent',
        inputRingFocusColor: 'focus:ring-blue-600',
        inputPlaceTextColor: 'placeholder:text-gray-400',
        iconBtnBg: 'bg-gray-100',
        avatarBg: 'bg-blue-50',
        switchBgActive: 'bg-blue-600',
        switchBgInactive: 'bg-gray-200',
        switchRingFocus: 'focus:ring-blue-600',
        bgGuideTour: 'bg-gradient-to-r from-blue-100 to-white',
        inverseBaseBg: 'bg-blue-600',
        checkboxBgInactive: 'bg-white',
        infoAlertBg: 'bg-blue-50',
        infoAlertTextColor: 'text-blue-700',
        infoAlertIconColor: 'text-blue-400',
        IconTextColor: 'text-blue-700',
        IconSvgColor: 'stroke-blue-700',
        svgColor: 'stroke-black',
        radioActiveBorderColor: 'border-blue-600',
        radioActiveRingColor: 'ring-blue-600',
        chartTheme: 'light',
        borderColorBtn: 'border-blue-600',
        iconBgSetting: 'bg-divider-white',
        iconBgSettingFillColor: 'fill-gray-600',

    },
    dark: {
        baseBg: 'bg-stone-900',
        secondBaseBg: 'bg-dark-blue',
        borderBlockColor: 'border-gray-600',
        baseTextColor: 'text-white',
        activeTabBg: 'bg-white/15',
        activeTabTextColor: 'text-white',
        tabTextColor: 'text-white/75',
        iconBgSettingTextColor: 'text-white',
        iconBgSettingFillColor: 'fill-white',
        cardBg: 'bg-white/5',
        cardBorderColor: 'border-white/20',
        cardLabelTextColor: 'text-white/65',
        lightButtonBg: 'bg-transparent',
        lightButtonTextColor: 'text-white',
        navBg: 'bg-black',
        navBorderColor: 'border-white/20',
        navActiveBg: 'bg-white/10',
        navActiveTextColor: 'text-white',
        navActiveTextColor2: 'text-yellow-300',
        borderColorCoin: 'border-transparent bg-transparent',
        dangerPnlColor: 'text-red-600',
        successPnlColor: 'text-lime-600',
        bgDangerColor: 'bg-red-600',
        bgSuccessPnlColor: 'bg-lime-600',
        loaderFill: 'fill-yellow-600',
        cardDivideColor: 'divide-white/20',
        cardDivideColor1: 'divide-white/10',
        menuBtnBg: 'bg-transparent',
        menuBtnTextColor: 'text-white/80',
        chartPlaceBg: 'bg-transparent',
        placeBg: 'bg-white/15',
        placeTextColor: 'text-white/15',
        outlineBtnBg: 'bg-yellow-100/15',
        outlineBtnTextColor: 'text-yellow-100',
        spinnerTextColor: 'text-yellow-300',
        inputRingColor: 'ring-white/20',
        inputBorderColor: 'border-white/20',
        inputRingFocusColor: 'focus:ring-white/20',
        inputPlaceTextColor: 'placeholder:text-white/20',
        inputBg: 'bg-blue-tr',
        tabsContainerBg: 'bg-white/15',
        iconBtnBg: 'bg-white/30',
        avatarBg: 'bg-yellow-50/20',
        switchBgActive: 'bg-blue-600',
        switchBgInactive: 'bg-white/20',
        switchRingFocus: 'focus:ring-yellow-400',
        bgGuideTour: 'bg-gradient-to-r from-yellow-900 to-stone-900',
        inverseBaseBg: 'bg-yellow-500',
        checkboxBgInactive: 'bg-white/20',
        infoAlertBg: 'bg-yellow-50',
        infoAlertTextColor: 'text-yellow-700',
        infoAlertIconColor: 'text-yellow-400',
        IconTextColor: 'text-yellow-400',
        IconSvgColor: 'stroke-yellow-400',
        svgColor: 'stroke-white',
        radioActiveBorderColor: 'border-yellow-400',
        radioActiveRingColor: 'border-yellow-400',
        chartTheme: 'dark',
        borderColorBtn: 'border-white/80',
        iconBgSetting: 'bg-divider'
    },
};